import {defineStore} from "pinia";
import {ref} from "vue";

export enum DialogLevel {
  Info = 'info',
  Success = 'success',
  Warning = 'warning',
  Error = 'error'
}

export const useDialogStore = defineStore('dialog', () => {
  const show = ref(false)
  const title = ref('')
  const text = ref('')
  const level = ref(DialogLevel.Info)

  function display(expectedTitle: string, expectedText: string, expectedLevel: DialogLevel) {
    title.value = expectedTitle
    text.value = expectedText
    level.value = expectedLevel
    show.value = true
  }

  function info(expectedTitle: string, expectedText: string) {
    display(expectedTitle, expectedText, DialogLevel.Info)
  }

  function warning(expectedTitle: string, expectedText: string) {
    display(expectedTitle, expectedText, DialogLevel.Warning)
  }

  function error(expectedTitle: string, expectedText: string) {
    display(expectedTitle, expectedText, DialogLevel.Error)
  }

  function success(expectedTitle: string, expectedText: string) {
    display(expectedTitle, expectedText, DialogLevel.Success)
  }

  return {error, info, level, show, success, text, title, warning}
})
